import { isBoolean } from 'lodash';

export const REFERRAL_HERO_SOURCE_CAMPAIGN = 'referralHeroSourceCampaign';
export const DASHBOARD_VISITED = 'dashboardVisited';

export const setRHSourceCampaign = source => {
  if (!source) return;

  window.sessionStorage.setItem(REFERRAL_HERO_SOURCE_CAMPAIGN, source);
};

export const getRHSourceCampaign = () => {
  return window.sessionStorage.getItem(REFERRAL_HERO_SOURCE_CAMPAIGN);
};

export const setDashboardVisitedSession = visited => {
  if (!isBoolean(visited)) return;

  window.sessionStorage.setItem(DASHBOARD_VISITED, visited);
};

export const getDashboardVisitedSession = () => {
  return window.sessionStorage.getItem(DASHBOARD_VISITED);
};
